import React from 'react';

import { useTranslation } from 'react-i18next';
import { UserInfoWrapper, Icon, Text } from '../index.style';

const InsuranseInfo: React.FC<{}> = () => {
  const { t } = useTranslation();
  return (
    <UserInfoWrapper>
      <Icon />
      <Text>{t('insuranse_info_send')}</Text>
    </UserInfoWrapper>
  );
};

export default InsuranseInfo;
